import { useQuery } from "@tanstack/react-query"
import { apiClient } from "@/shared/api/client"
import type { Format } from "@/shared/lib/types"

const fetchFormats = async (): Promise<Format[]> => {
	const { data } = await apiClient.get<Format[]>("/formats")
	return data
}

export const useFormats = () => {
	return useQuery({
		queryKey: ["formats"],
		queryFn: fetchFormats,
	})
}

export const usePostTypes = useFormats
